import disconnectedCallback from '@common/lifecycles/disconnectedCallback'

import visibilityObserver from '@common/IntersectionObserver/visibilityObserver'

import anim from '../anim'

import { ERouterEvent } from './definitions'

const VISIBILITY_ANIM_DURATION = 1700

function onContentChanged (): void {
  const elements = Array.from(document.body.querySelectorAll('[data-visibility]'))

  elements.forEach((elem) => {
    const observer = visibilityObserver({
      onVisible: () => {
        anim.add(elem, 'fadeIn', VISIBILITY_ANIM_DURATION)

        observer.unobserve(elem)
      }
    })

    observer.observe(elem)

    disconnectedCallback(elem, () => {
      observer.unobserve(elem)
    })
  })
}

document.addEventListener(ERouterEvent.ContentChanged, onContentChanged)
